import axios from "axios";
import { PROGRAMS, PROGRAMS_ARE_LOADING, PROGRAMS_DEGREES, PROGRAMS_DEGREES_LOADING, PROGRAM_LOADED, PROGRAM } from "../constants/programs";

import { API_URL } from "../config/config";
import { SOURCE, ORGANIZATION } from "../constants/global";

export function fetchProgramsDegrees(params) {
  return (dispatch) => {
    dispatch(programsDegreesAreLoading(true));

    const config = { params: { source: SOURCE, ...params } };

    return axios
      .get(`${API_URL}degrees`, config)
      .then((response) => {
        return response;
      })
      .then((response) => {
        dispatch(programsDegreesSuccess(response.data.data));
        dispatch(programsDegreesAreLoading(false));

        return response;
      })
      .catch((e) => console.log("error loading programs degrees", e));
  };
}

function programsDegreesAreLoading(bool) {
  return {
    type: PROGRAMS_DEGREES_LOADING,
    bool,
  };
}

function programsDegreesSuccess(data) {
  return {
    type: PROGRAMS_DEGREES,
    data,
  };
}

export function fetchPrograms() {
  return (dispatch) => {
    dispatch(programsAreLoading(true));

    const config = { params: { source: SOURCE } };

    return axios
      .get(`${API_URL}orgs/${ORGANIZATION}/programs`, config)
      .then((response) => {
        dispatch(programsSuccess(response.data.data));
        dispatch(programsAreLoading(false));

        return response;
      })
      .catch((e) => {
        console.log("error loading programs", e);
      });
  };
}

function programsAreLoading(bool) {
  return {
    type: PROGRAMS_ARE_LOADING,
    bool,
  };
}

function programsSuccess(data) {
  return {
    type: PROGRAMS,
    data,
  };
}

export function fetchProgram(id) {
  return (dispatch) => {
    dispatch(programIsLoaded(true));

    const config = { params: { source: SOURCE } };

    return axios
      .get(`${API_URL}programs/${id}`, config)
      .then((response) => {
        dispatch(programSuccess(response.data.data));
        dispatch(programIsLoaded(true));
        return response;
      })
      .catch((e) => {
        console.log("error loading program", e);
        dispatch(programIsLoaded(false));
      });
  };
}

function programIsLoaded(bool) {
  return {
    type: PROGRAM_LOADED,
    bool,
  };
}

function programSuccess(data) {
  return {
    type: PROGRAM,
    data,
  };
}
